// extracted by mini-css-extract-plugin
module.exports = {"teamPin":"AboutUsPageTemplate-module--team-pin--ROzqR","sectionDivider":"AboutUsPageTemplate-module--section-divider--2vn-u"};